// extracted by mini-css-extract-plugin
export default {"createNewsContainer":"createNews_createNewsContainer__v154O","statusMessage":"createNews_statusMessage__BBenE","error":"createNews_error__8zoXb"};